// src/utils/dateHelpers.js
export function formatHeure(dateInput) {
  if (!dateInput) return "—";

  const date = new Date(dateInput);
  const heures = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${heures}h${minutes}`;
}

export function toISODateLocal(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`; // -> "YYYY-MM-DD" en heure locale
}

export const showDateTime = (v) => {
  if (!v) return '—';
  let s = String(v);
  if (s.includes(' ') && !s.includes('T')) s = s.replace(' ', 'T');
  const d = new Date(s);
  if (isNaN(d)) return '—';
  return d.toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
// utils/dates.js
export const showTime = (v) => {
  if (!v) return "—";
  let s = String(v);
  // Ex: "2025-08-13 23:19:27.250509+00" -> "2025-08-13T23:19:27.250509+00"
  if (s.includes(" ") && !s.includes("T")) s = s.replace(" ", "T");
  const d = new Date(s);
  if (isNaN(d)) return "—";
  return d.toLocaleTimeString("fr-FR", {
    timeZone: "Europe/Paris",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const showTimeWDate = (v) => {
  if (!v) return "—";
  let s = String(v);
  return new Date(s)
    .toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
    .replace(',', '');
};

export function fromNow(d) {
  if (!d) return "—";
  const ms = Date.now() - new Date(d).getTime();
  const m = Math.max(0, Math.round(ms / 60000));
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60),
    mm = m % 60;
  return `${h}h${String(mm).padStart(2, "0")}`;
}
